import { CSSProperties, useState } from 'react';
import { Key, ToggleButton, ToggleButtonGroup } from '@backstage/ui';

import styles from './LabeledSwitch.module.css';

interface LabeledSwitchProps {
  options: {
    firstOption: string;
    secondOption: string;
  };
  /** Called every time the active option changes. */
  onSwitch: () => void;
  className?: string;
  style?: CSSProperties;
  'aria-label'?: string;
}

const FIRST_OPTION = 'first';
const SECOND_OPTION = 'second';

export const LabeledSwitch = (props: LabeledSwitchProps) => {
  const { options, onSwitch, className, style } = props;

  const [switched, setSwitched] = useState(false);

  const handleSelectionChange = (keys: Set<Key>) => {
    const next = keys.has(SECOND_OPTION);
    if (next === switched) {
      return;
    }
    setSwitched(next);
    onSwitch();
  };

  return (
    <ToggleButtonGroup
      selectionMode="single"
      disallowEmptySelection
      selectedKeys={[switched ? SECOND_OPTION : FIRST_OPTION]}
      onSelectionChange={handleSelectionChange}
      aria-label={props['aria-label']}
      className={[styles.root, className].filter(Boolean).join(' ')}
      style={style}
      data-switched={switched}
    >
      <span className={styles.thumb} aria-hidden="true" />
      <ToggleButton id={FIRST_OPTION} className={styles.option}>
        {options.firstOption}
      </ToggleButton>
      <ToggleButton id={SECOND_OPTION} className={styles.option}>
        {options.secondOption}
      </ToggleButton>
    </ToggleButtonGroup>
  );
};
